import { windowWidth } from "./utils";

const descMenu = {
  links: document.querySelectorAll(
    ".jsDescMenuLink"
  ) as NodeListOf<HTMLElement>,
  subMenus: document.querySelectorAll(
    ".jsDescSubMenu"
  ) as NodeListOf<HTMLElement>,
  header: document.getElementById("header") as HTMLElement,
  menu: document.getElementById("jsMegaMenu") as HTMLElement,
  deskOverlay: document.getElementById("deskOverlay") as HTMLElement,
  closeMenu: document.querySelectorAll(".jsCloseMenu") as NodeListOf<HTMLElement>,

  init() {
    if (windowWidth > 1024) {
      this.toggleMenu();       
      this.setCloseAll();
    }
  },
  toggleMenu() {
    this.links.forEach((item, index) => {
      item.addEventListener("mouseenter", (e) => {      
        this.header.classList.add("activeClass");
        this.deskOverlay.classList.add("activeClass");
        item.classList.add("activeClass");
        this.subMenus[index].classList.remove("d-none");
      });
      item.addEventListener("mouseleave", (e) => {       
        this.header.classList.remove("activeClass");
        item.classList.remove("activeClass");
        this.deskOverlay.classList.remove("activeClass");
        this.subMenus[index].classList.add("d-none");   
      });
    });
  },

  resetClasses() {
    this.links.forEach((item) => item.classList.remove("activeClass"))
    this.subMenus.forEach((item) => item.classList.add("d-none"))
    this.header.classList.remove("activeClass")
    this.deskOverlay.classList.remove("activeClass")

  },
  setCloseAll(){
    this.closeMenu.forEach(item=>{
      item.addEventListener('click', ()=>{
        this.resetClasses()
      })
    })
  },


};

export default descMenu;